var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.4517 9.86278C10.6141 10.0256 10.6139 10.2893 10.4511 10.4518C10.2884 10.6144 10.0247 10.6143 9.86207 10.4517C9.69942 10.289 9.69934 10.0253 9.86188 9.86259C10.0244 9.69984 10.2881 9.69959 10.451 9.86203L10.4517 9.86278",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M30.9914 12.8439C25.9809 12.0737 20.9031 13.7363 17.3185 17.3209C13.7339 20.9055 12.0712 25.9833 12.8414 30.9939",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6567 0.990585H9.32332C4.72095 0.990585 0.98999 4.72155 0.98999 9.32392V22.6573C0.98999 27.2596 4.72095 30.9906 9.32332 30.9906H22.6567C27.259 30.9906 30.99 27.2596 30.99 22.6573V9.32392C30.99 4.72155 27.259 0.990585 22.6567 0.990585Z",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup);
export default ForwardRef;